import { Chip, Typography } from '@mui/material';

interface SourceChipProps {
  source: string;
}

export const SourceChip = ({ source }: SourceChipProps) => {
  return (
    <Chip
      label={
        <Typography variant="caption" color="text.secondary">
          From: {source}
        </Typography>
      }
      size="small"
      sx={{ borderRadius: '8px' }}
    />
  );
};
